import { render, staticRenderFns } from "./BlockLeavePolicy.vue?vue&type=template&id=61cf3030&"
import script from "./BlockLeavePolicy.vue?vue&type=script&lang=js&"
export * from "./BlockLeavePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cf3030')) {
      api.createRecord('61cf3030', component.options)
    } else {
      api.reload('61cf3030', component.options)
    }
    module.hot.accept("./BlockLeavePolicy.vue?vue&type=template&id=61cf3030&", function () {
      api.rerender('61cf3030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/BlockLeave/BlockLeavePolicy/BlockLeavePolicy.vue"
export default component.exports